import {InjectGoogleMaps} from './inject-google-maps.js';
import {AjaxRequest} from '../../utils/ajax-request.js';

export class LocationsMap {

	node;
	map;
	cluster;
	data = [];
	markers = [];

	constructor(querySelector) {
		this.node = document.querySelector(querySelector);
		this.countNode = document.querySelector(querySelector + '__count');
	}

	init() {
		let self = this;

		if (! self.node) {
			return;
		}

		InjectGoogleMaps()
			.then(() => self.doInit())
			.catch(e => {
				console.error('Error loading Google Maps', e);
			});
	}

	doInit() {
		if (!window.google) {
			return;
		}

		let self = this;
		let url = self.node.dataset.mapUrl;

		if (! url) {
			console.error('Missing dataset `data-map-url` for deals map initialization!');
			return;
		}

		self.data = self.getMapData(url);
	}

	renderMap() {
		let self = this;
		let mapProp = {
			center: {lat: Number(self.node.dataset.lat), lng: Number(self.node.dataset.lng)},
			zoom: 4,
			scrollwheel: true,
			panControl: true,
			zoomControl: true,
			scaleControl: true,
			mapTypeControl: false,
			streetViewControl: false,
			mapTypeId: window.google.maps.MapTypeId.ROADMAP
		};

		self.map = new window.google.maps.Map(self.node, mapProp);
		self.setupMarkers();
	}

	updateMarkers(data) {
		let self = this;
		self.data = data;

		// not init yet
		if (! self.cluster) {
			self.renderMap();

			return;
		}

		self.cleanMap();
		self.setupMarkers();
	}

	setupMarkers() {
		let self = this;

		self.createMarkers();

		if (self.markers.length) {
			self.map.fitBounds(
				self.fitMarkers()
			);
		}

		self.updateMarksCount();
	}

	cleanMap() {
		let self = this;

		for (let i = 0; i < self.markers.length; i++){
			self.markers[i].setMap(null);
		}
		self.markers = [];
		if (self.cluster) {
			self.cluster.clearMarkers();
		}
	}

	updateMarksCount() {
		let self = this;

		if (self.countNode) {
			self.countNode.innerHTML = " " + self.markers.length + "";
		}
	}

	createMarkers(callback) {
		let self = this;

		if (self.data) {
			self.data.forEach((data) => {
				let lat = data.lat;
				let lng = data.lng;
				let latLng = {lat: Number(lat), lng: Number(lng)};
				let contentString = `<div class="c-map-info-box">
					<a class="c-map-info-box__link" href="${data.url}" target="_blank">
						<div class="c-map-info-box__image" style="background-image: url('${data.image}');"></div>
						<div class="c-map-info-box__content">
							<h3 class="c-map-info-box__headline">${data.name}</h3>
							<span class="c-map-info-box__button c-button c-button--primary c-button--outline c-button--smaller" href="${data.url}">${data.button}</span>
						</div>
					</a>
				</div>`;

				let markerImg = {
					url: self.node.dataset.marker,
					size: new window.google.maps.Size(40, 50),
					scaledSize: new window.google.maps.Size(40, 50)
				};

				let marker = new window.google.maps.Marker({
					position: latLng,
					map: self.map,
					icon: markerImg
				});

				marker.snazzyInfoWindowInstance = new window.SnazzyInfoWindow({
					marker: marker,
					placement: 'top',
					content: contentString,
					maxWidth: 640,
					panOnOpen: false,
					closeWhenOthersOpen: true,
					offset: {
						top: '-55px'
					}
				});

				window.google.maps.event.addListener(marker, "click", function (e) {
					let bounds = self.map.getBounds();
					let north = bounds.getNorthEast().lat();
					let south = bounds.getSouthWest().lat();

					let transition = (north - south) / 4;
					self.map.setCenter({lat: marker.getPosition().lat() + transition, lng: marker.getPosition().lng()});
				});

				self.markers.push(marker);
			});
		}

		self.cluster = new MarkerClusterer(self.map, self.markers, {
			gridSize: 30,
			maxZoom: 8,
			averageCenter: true,
			minimumClusterSize: 5,
			styles: [
				{
					textColor: '#FFA82C',
					backgroundPosition: 'center',
					url: self.node.dataset.clusterImg,
					width: 42,
					height: 42
				}
			]
		});
	}

	fitMarkers() {
		if (this.markers.length) {
			let bounds = new window.google.maps.LatLngBounds();

			for (let m in this.markers) {
				bounds.extend(this.markers[m].getPosition());
			}

			return bounds;
		}
	}

	getMapData(url) {
		let self = this;

		AjaxRequest.create(url)
			.then(result => {
				self.data = result.pins;
				self.renderMap();
			})
			.catch(err => AjaxRequest.handleError(err));
	}
}

window.LocationsMap = new LocationsMap('.js-map-listing');
